import { createMiddleware } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';
import { requireAuth } from '@/lib/auth';

/**
 * Function-level auth for server functions. A route `beforeLoad` does NOT
 * protect a server-function RPC URL, so every protected `createServerFn` must
 * attach this middleware. `requireAuth` returns a 401 `Response` when the
 * session cookie is missing/invalid (preserving the `INTERNAL_SCAN_SECRET`
 * bearer-token bypass); throwing that `Response` short-circuits the RPC.
 */
export const authMiddleware = createMiddleware({ type: 'function' }).server(
  async ({ next }) => {
    const denied = requireAuth(getRequest());

    if (denied) {
      throw denied;
    }

    return next();
  },
);
